import { render, staticRenderFns } from "./SysMaintenanceDashboard.vue?vue&type=template&id=118db501&scoped=true"
import script from "./SysMaintenanceDashboard.vue?vue&type=script&lang=js"
export * from "./SysMaintenanceDashboard.vue?vue&type=script&lang=js"
import style0 from "./SysMaintenanceDashboard.vue?vue&type=style&index=0&id=118db501&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118db501",
  null
  
)

export default component.exports